var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMango = function SvgMango(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mango_svg__a)",
    d: "M130.69 77.2c-45.968 6.436-102.956 44.217-97.3 74.483 6.02 32.21 59.183 48.314 111.344 40.262S231 151.686 231 119.477c0-31.203-57.176-48.314-100.31-42.277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mango_svg__b)",
    d: "M228.624 113s6.376 1.556 7.3 2.588a7.3 7.3 0 0 1 .92 5.158 19.84 19.84 0 0 1-8.287 8.254s-3.547-8.271.067-16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mango_svg__a",
    x1: 33,
    x2: 231,
    y1: 134.998,
    y2: 134.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B89BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mango_svg__b",
    x1: 227.19,
    x2: 237.027,
    y1: 121.032,
    y2: 120.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3295C1"
  })))));
};
export default SvgMango;